export var defaultImageCardDimensions = {
  width: 156,
  height: 125
};
export var defaultHorizontalCardDimensions = {
  width: 435,
  height: 125
};
export var defaultSquareCardDimensions = {
  width: 300,
  height: 300
};
export var getDefaultCardDimensions = function getDefaultCardDimensions(appearance) {
  if (appearance === 'image') {
    return defaultImageCardDimensions;
  }
  if (appearance === 'square') {
    return defaultSquareCardDimensions;
  }
  if (appearance === 'horizontal') {
    return defaultHorizontalCardDimensions;
  }
  return defaultImageCardDimensions;
};